export default __webpack_public_path__ + "static/bea784e252d76832239ece416b36c66b.jpg";